import { HOME } from '../../../routes/paths';
import { Box, CircularProgress, Grid } from '@mui/material';
import dayjs from 'dayjs';
import { IconWrapper } from '../../components/general/stylesComponents/stylesComponents';
import { useExport } from './hook';
import { ExportMessages } from '../../../shared/messages/exportMessages';
import FormView from '../../components/views/formView';
import FieldSelect from '../../components/general/fields/fieldSelect';
import DownloadIcon from '@mui/icons-material/Download';
import DateTimePickerField from '../../components/general/fields/dateTimePickerField';

const Export = () => {
    const { TITLE } = ExportMessages;
    const {
        formik,
        navigate,
        loading,
        surveyCodeOptions,
        surveyTitleOptions,
        surveyList,
    } = useExport();

    return (
        <>
            <FormView
                title={TITLE}
                onClickSave={formik.handleSubmit}
                onClickBack={() => navigate(HOME)}
                saveTitle="Descargar"
                saveIcon={<DownloadIcon />}
            />
            {loading ? (
                <IconWrapper>
                    <CircularProgress size={70} thickness={2} />
                </IconWrapper>
            ) : (
                <Box mt={3} px={2}>
                    <Grid
                        container
                        spacing={{ xs: 1.5, md: 1.5 }}
                        columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
                    >
                        <Grid item xs={12} md={4}>
                            <DateTimePickerField
                                label="Fecha inicio"
                                name="startDate"
                                size="small"
                                required={true}
                                maxDate={dayjs()}
                                touched={formik.touched.startDate}
                                errors={formik.errors.startDate?.toString()}
                                value={formik.values.startDate}
                                onChange={(value) =>
                                    formik.setFieldValue(
                                        'startDate',
                                        value,
                                        true
                                    )
                                }
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <DateTimePickerField
                                label="Fecha fin"
                                name="endDate"
                                size="small"
                                required={true}
                                maxDate={dayjs()}
                                minDate={dayjs(formik.values.startDate)}
                                touched={formik.touched.endDate}
                                errors={formik.errors.endDate?.toString()}
                                value={formik.values.endDate}
                                onChange={(value) =>
                                    formik.setFieldValue('endDate', value, true)
                                }
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <FieldSelect
                                data={surveyCodeOptions}
                                label="Código encuesta"
                                name="surveyCode"
                                size="small"
                                touched={formik.touched.surveyCode}
                                errors={formik.errors.surveyCode}
                                value={formik.values.surveyCode}
                                onChange={(e) => {
                                    const selectedCode = e.target.value;
                                    formik.setFieldValue(
                                        'surveyCode',
                                        selectedCode
                                    );

                                    const matchedSurvey = surveyList.find(
                                        (s) => s.code === selectedCode
                                    );
                                    formik.setFieldValue(
                                        'surveyTitle',
                                        matchedSurvey?.title || ''
                                    );
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <FieldSelect
                                data={surveyTitleOptions}
                                label="Título encuesta"
                                name="surveyTitle"
                                size="small"
                                touched={formik.touched.surveyTitle}
                                errors={formik.errors.surveyTitle}
                                value={formik.values.surveyTitle}
                                onChange={(e) => {
                                    const selectedTitle = e.target.value;
                                    formik.setFieldValue(
                                        'surveyTitle',
                                        selectedTitle
                                    );

                                    const matchedSurvey = surveyList.find(
                                        (s) => s.title === selectedTitle
                                    );
                                    formik.setFieldValue(
                                        'surveyCode',
                                        matchedSurvey?.code || ''
                                    );
                                }}
                            />
                        </Grid>
                    </Grid>
                </Box>
            )}
        </>
    );
};

export default Export;
